declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../animations/router.animations';
import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, ExpenseVoucherController, ExpenseVoucherRequest, ExpenseVouchersRequest, ExpenseVouchersController, SaveExpenseVoucherRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
//import { NgbAddNewPatient } from '../../../modal/addnewpatient.modal';
import { NgbCameraUploadModal } from '../profile/patientprofileview/personaldetailview/modal/cameraupload.modal';
import { NgbViewItemDetailsModal } from './modal/viewitemdetails.modal';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { ExpenseVoucherpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgxSpinnerService } from 'ngx-spinner';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';





@Component({
  selector: 'expenseman',
  templateUrl: './expenseman.component.html',
  styleUrls: [
    './expenseman.component.scss']
  , animations: [routerTransition()]
})

export class ExpenseManComponent implements OnInit {

 
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }

  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
public DetailsSection:boolean=false;
  public ShowRegister: boolean = true;
  public Showrow: boolean = true;
  public ShowPatientDetails: boolean = false;
  public isRequesting: boolean = false;
  public searchValue: string;
    public searchText: any;
  TodayDate = new Date();
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
    SelectedFromDate: NgbDateStruct;
    SelectedToDate: NgbDateStruct;
   
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;

  CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
  CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;
    CurrentExpenseVouchersController: ExpenseVouchersController[];
    CurrentExpenseVouchersRequest: ExpenseVouchersRequest;

    LoadForms() {
        this.CurrentExpenseVouchersRequest = new ExpenseVouchersRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentExpenseVouchersRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.pdata = this.CurrentExpenseVouchersController;
       // this.pdata = this.CurrentFollicularScansBetweenDateController;
        this.GetExpenseVouchersController();
    }
    //public SelectedReport: string;

    GetExpenseVouchersController() {
        this.StartRefreshing();
        //this.spinner.show();
        this.CurrentExpenseVouchersRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
        this.CurrentExpenseVouchersRequest.FromDate = new Date();
        this.CurrentExpenseVouchersRequest.ToDate = new Date();
        this.CurrentExpenseVouchersRequest.ConditionalOperator = 10;
        //alert(this.FormattedCode);
        this.actorservice.GetExpenseVouchersController(this.CurrentExpenseVouchersRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentExpenseVouchersController = this.ApiResData.Result;
                    this.pdata = this.CurrentExpenseVouchersController;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
                    //this.spinner.hide();
                    this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.LoadOvaryData();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }



  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    public printService: PrintService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
      private loginservice: LoginService, private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService, private filter: ExpenseVoucherpipe, private spinner: NgxSpinnerService,) { }

  ngOnInit() {

    this.CurrentActorDashBoardProfileSummaryInfoRequest = new ActorDashBoardProfileSummaryInfoRequest();
    this.CurrentDashBoardProfileSummaryController = new DashBoardProfileSummaryController();

      this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
      this.SelectedToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };

    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
      this.isNew = true;
     

    this.CurrentActorDashBoardProfileSummaryInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDashBoardProfileSummaryController();
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.SelectedPatient.FormattedCode;
      this.LoadForms();
    //this.GetPatientInfoByFormattedCodeController();

  }



  ShowList: boolean = true;

  GetDashBoardProfileSummaryController() {
    //  console.log(this.CurrentActorProfileRequest.SendApiRequestModel.xAuthGenKEY);
    this.StartRefreshing();
    this.hcpservice.GetDashBoardProfileSummaryController(this.CurrentActorDashBoardProfileSummaryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //  console.log('GetActorProfileController');
          this.CurrentDashBoardProfileSummaryController = this.ApiResData.Result[0];
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }


  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

    Go() {
        this.spinner.show();
        this._GetExpenseVouchersController();
    }
    _GetExpenseVouchersController() {
        this.StartRefreshing();
        //this.spinner.show();
        this.CurrentExpenseVouchersRequest.FacilityCode = this.SelectedFacilityCode;
        this.CurrentExpenseVouchersRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
        this.CurrentExpenseVouchersRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedToDate));
        this.CurrentExpenseVouchersRequest.ConditionalOperator = 20;
        //alert(this.FormattedCode);
        this.actorservice.GetExpenseVouchersController(this.CurrentExpenseVouchersRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentExpenseVouchersController = this.ApiResData.Result;
                    this.pdata = this.CurrentExpenseVouchersController;
                    this.spinner.hide();
                    // this.pdata = this.CurrentFollicularScansBetweenDateController;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
                    //this.spinner.hide();
                    this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.LoadOvaryData();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    pdata: any[];// = this.data;
    listFilter: string;

    criteriaChange(value: any) {
        if (this.filter != null) {
            if (value != '[object Event]') {
                this.listFilter = value;
                //alert(this.listFilter);
                this.pdata = this.filter.transform(this.CurrentExpenseVouchersController,
                    this.listFilter);
            }
        }
    }
    SelectedFacilityCode: number;
    Roleassign(event: any) {

        if (event != null) {

           // alert(event);
        }

    }
  //AddNewPatient() {

  //  const modalRef = this.modalService.open(NgbAddNewPatient,
  //    {
  //      centered: true,
  //      size: "lg",
  //      backdrop: 'static',
  //      keyboard: false
  //    })
  //  modalRef.componentInstance.ActorCode = this.ActorCode;
    
  //  modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })

  //}
  CancelNewOperation() {

    this.ShowList = true;
  }

  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }

  SelectedPatient: PatientInfoByFormattedCodeController;
  ViewPatientDetails(objCategory: any) {
    var patient: PatientInfoByFormattedCodeController = objCategory;

    if (patient != null) {



      this.ShowPatientDetails = true;
      this.ShowList = false;
      this.SelectedPatient = patient;
      this.Showarrow = true;
      this.Showrow = false;
      this.ShowRegister = false;
      //this.LoadPatientdetails()

    }
    else {
      this.ShowPatientDetails = false;
    }
  }
  //SelectedPatientDetailsController: PatientInfoByFormattedCodeController;
  //SelectedPatientDetailsRequest: PatientInfoByFormattedCodeRequest;
  //LoadPatientdetails() {


  //  this.SelectedPatientDetailsRequest = new PatientInfoByFormattedCodeRequest();

  //  this.SelectedPatientDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.SelectedPatientDetailsRequest.FormattedCode = this.SelectedPatient.ActorCode.toString();// AppData.Instance().UserLoginDetails.FacilityActorCode;
  //  this.GetPatientInfoByFormattedCodeController();
  //}

 
    DecrementDate() {
        //this.dateI = new Date();
        //var i = this.dateI.valueOf() + 86400000;
        //this.dateI = new Date(i);
        //this.SelectedFromDate = dateI;
        //var ind: number = 0;
        //this.diff = this.diff - 1;
        //alert(this.diff);

        var monthNo = this.SelectedFromDate.month
        var d: Date = new Date(
            this.SelectedFromDate.year,
            monthNo - 1,
            this.SelectedFromDate.day
        );
        //this.parserFormatter.parse(this.SelectedFromDate).;

        d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
        //    d.getFullYear
        //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

        //  this.SelectedFromDate = this.SelectedFromDate.
        this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
        //this._GetBillDetailsInfoController();
        //ind++;
    }
    IncrementDate() {
        //this.dateI = new Date();
        //var i = this.dateI.valueOf() + 86400000;
        //this.dateI = new Date(i);
        //this.SelectedFromDate = dateI;
        //var ind: number = 0;
        //this.diff = this.diff - 1;
        //alert(this.diff);
        var monthNo = this.SelectedFromDate.month
        var d: Date = new Date(
            this.SelectedFromDate.year,
            monthNo - 1,
            this.SelectedFromDate.day
        );
        //this.parserFormatter.parse(this.SelectedFromDate).;

        d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
        //    d.getFullYear
        //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

        //  this.SelectedFromDate = this.SelectedFromDate.
        this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
        //this._GetBillDetailsInfoController();
        //ind++;
    }
 
  capture(l: PatientInfoByFormattedCodeController) {
    const modalRef = this.modalService.open(NgbCameraUploadModal,
      {
        centered: true,


      })
    modalRef.componentInstance.ActorCode = l.ActorCode;
    modalRef.componentInstance.Photo = l.Photo;
  }
  ClearInput() {
    this.searchValue = '';
    // this.searchValue = null;
    //var searchtext = '';
   // this.RefreshPatients(this.searchValue);
  }
    ViewOrder() {
        this.router.navigate(['/healins/vieworder']);
    }
  dataChanged(newobj) {

  }
  Payment() {

  }
DisplaySelected(){
this.DetailsSection=true;
}
    RefundItems() {
        this.router.navigate(['/healins/Refundrequest']);
    }
  AddNewPatient() {

    }
    ViewItem(l: ExpenseVouchersController) {
        //var Datetosend: NgbDateStruct;
        //var Datetosend = { year: l.ReceiptDate.getFullYear(), month: l.ReceiptDate.getMonth() + 2, day: l.ReceiptDate.getDate() };;

        const modalRef = this.modalService.open(NgbViewItemDetailsModal,
            {
                centered: true

            })
        modalRef.componentInstance.Voucherno = l.VoucherNo;
        modalRef.componentInstance.TotalAmount = l.TotalAmount;
        modalRef.componentInstance.ReDate = l.ReceiptDate;

    }

  printexpenses() {
    this.printService.printDocument("expensesreport",
      {
        SelectedFromDate: this.SelectedFromDate, SelectedToDate: this.SelectedToDate, Day: this.SelectedFromDate.day, year: this.SelectedFromDate.year, month: this.SelectedFromDate.month
      }
    );
  }

}
